import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import PrimaryTheme from '../Themes/Primary';
import DialogActions from '@material-ui/core/DialogActions';
import Input from './Input';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Reducers } from '../Interfaces/Interfaces';
import StatusAlert from './StatusAlert';
import { changePassword, getUserDetails } from '../redux/actions/userActions';

export default function ChangePassword() {
  const alert = useSelector((state: Reducers) => state.alert);
  const user = useSelector((state: Reducers) => state.user);


  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [oldPassword, setOldPassword] = React.useState('');
  const [newPassword, setNewPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [isPasswordValid, setPasswordValid]: any = React.useState(null);
  const [isPasswordMatch, setPasswordMatch]: any = React.useState(null);
  const [submitted, setSubmitted]: any = React.useState(false);
  const [visible, setVisibility] = React.useState(false);


  const handleRefresh = () => {
    dispatch({
      type: 'LOADING',
      payload: true
    });
    dispatch({
      type: "STATUS_ALERT",
      payload: false
    });

    setPasswordMatch(null);
    setPasswordValid(null);
    setSubmitted(false);
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");

    dispatch(getUserDetails(user.phoneNumber));
  }

  const validatePassword = (text: any) => {
    let reg = /(?=.*\d)(?=.*[a-z]*[A-Z]).{6,}/;
    // min 6 chars
    //  number required
    //   uppercase letter
    if (!reg.test(text)) {
      setPasswordValid(false);
      setNewPassword(text);
    } else {
      setPasswordValid(true);
      setNewPassword(text);
    }
  };

  const matchPassword = (text: string) => {
    setConfirmPassword(text);
    if (text === newPassword) {
      setPasswordMatch(true);
    } else {
      setPasswordMatch(false);
    }
  }

  const handleSubmit = () => {
    let data = {
      oldPassword,
      newPassword,
      confirmPassword
    }

    setSubmitted(true);
    setVisibility(false);

    dispatch(changePassword(data));

  }

  const goBack = () => {
    dispatch({
      type: "STATUS_ALERT",
      payload: false
    });
    history.push('/dashboard');
  }

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: 'LOADING',
          payload: false
        })

        dispatch({
          type: 'ALERT',
          payload: {}
        });

        setSubmitted(false);

      } else {

        // enqueueSnackbar(alert.message, { variant: "success" });
        // handleRefresh();

        dispatch({
          type: "STATUS_ALERT",
          payload: true
        });

        dispatch({
          type: 'ALERT',
          payload: {}
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, enqueueSnackbar, alert, history]);

  return (
    <div className="col-md-12  modal-container">

      <DialogContent>

        <div className="col-md-12 p-0">
          <label htmlFor="old-password" style={{
            fontFamily: PrimaryTheme.fonts?.RubikMedium,
            fontSize: PrimaryTheme.fontSizes?.small,
            textTransform: "uppercase"
          }}>Old Password</label>

          <Input
            type={visible ? "text" : "password"}
            inputMode="text"
            isInput
            showIcon
            required
            isPassword
            id="old-password"
            placeholder='Enter old password'
            value={oldPassword}
            visibilityIcon={visible ? "visibility_off" : "visibility"}
            onIconClick={() => setVisibility(!visible)}
            onChange={(e) => setOldPassword(e.target.value)}
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
            }} />
        </div>

        <div className="col-md-12 p-0">
          <label htmlFor="new-password" style={{
            fontFamily: PrimaryTheme.fonts?.RubikMedium,
            fontSize: PrimaryTheme.fontSizes?.small,
            textTransform: "uppercase"
          }}>New Password</label>

          <Input
            type={visible ? "text" : "password"}
            inputMode="text"
            isInput
            showIcon
            required
            valid={isPasswordValid}
            id="new-password"
            value={newPassword}
            onChange={(e) => validatePassword(e.target.value)}
            placeholder='Enter New Password'
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
            }} />
        </div>

        <div className="col-md-12 p-0">
          <label htmlFor="confirm-password" style={{
            fontFamily: PrimaryTheme.fonts?.RubikMedium,
            fontSize: PrimaryTheme.fontSizes?.small,
            textTransform: "uppercase"
          }}>Confirm Password</label>

          <Input
            type={visible ? "text" : "password"}
            inputMode="text"
            isInput
            showIcon
            required
            id="confirm-password"
            placeholder='Confirm New Password'
            valid={isPasswordMatch}
            value={confirmPassword}
            onChange={(e) => matchPassword(e.target.value)}
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,
              padding: '1.1rem',
              borderRadius: 100
            }} />
        </div>

      </DialogContent>

      <DialogActions>
        <div className="col-md-8 ml-auto mr-auto mb-0">

          <Input
            type="button"
            isInput
            id="confirm-password"
            value={submitted ? "Changing..." : "Change Password"}
            disabled={submitted ||
              oldPassword === "" ||
              newPassword === "" ||
              confirmPassword === "" ||
              (!isPasswordValid && isPasswordValid !== null) ||
              (!isPasswordMatch && isPasswordMatch !== null)
            }
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikBold,
              backgroundColor: PrimaryTheme.primary,
              color: PrimaryTheme.white,
              padding: '1.1rem',
              borderRadius: 100
            }}
            onClick={handleSubmit}
          />
        </div>
      </DialogActions>

      <StatusAlert
        title={"Password Changed Successfully"}
        subtitle={"Your password has changed successfully."}
        buttonTitle="Done"
        backTitle="Back to dashboard"
        goBack={goBack}
        onClick={handleRefresh}
      ></StatusAlert>

    </div>

  )
}
